import { useEffect, useState } from "react";
import {
  loginCompanyID,
  loginEmployeeID,
  loginJsonBody,
  loginPartyID,
  loginSelectedPartyID,
} from "../../../../components/Common/CommonFunction";
import {
  CompanyGroup_Get_API,
  Module_Get_API,
  PageMaster_Get_API,
  PartySettingApi,
  Party_Master_Optimize_Get_API,
  Post_General_List_Api,
  RoleAccessAdd_List_Api,
  Role_Master_Get_API,
  TransactionLog_Get_OnDashBoard_Api,
  User_Component_GetMethod_API,
  fetch_CompanyList,
  get_EmployeelistApi,
} from "../../../../helpers/backend_helper";
import { EMPTY_DASHBOARD_DATA } from "../constants/theme";
import { normalizeApiData } from "../utils/formatters";

const useDashboardData = () => {
  const [data, setData] = useState(EMPTY_DASHBOARD_DATA);
  const [loading, setLoading] = useState(true);
  const [sectionLoading, setSectionLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchDashboardData = async () => {
      setLoading(true);
      setSectionLoading(true);

      const defaultBody = loginJsonBody();
      const listBody = JSON.stringify(defaultBody);
      const partyBody = JSON.stringify({
        ...defaultBody,
        PartyID: loginSelectedPartyID(),
        IsRetailer: 0,
        EmployeeID: loginEmployeeID(),
      });
      const generalBody = JSON.stringify({ TypeID: 2, Company: loginCompanyID() });

      const requests = {
        companies: fetch_CompanyList(listBody),
        companyGroups: CompanyGroup_Get_API(),
        users: User_Component_GetMethod_API(listBody),
        parties: Party_Master_Optimize_Get_API(partyBody),
        modules: Module_Get_API(),
        pages: PageMaster_Get_API(),
        roles: Role_Master_Get_API(listBody),
        roleAccess: RoleAccessAdd_List_Api(defaultBody),
        employees: get_EmployeelistApi(listBody),
        generalMasters: Post_General_List_Api(generalBody),
        settings: PartySettingApi(loginPartyID(), loginCompanyID()),
        logs: TransactionLog_Get_OnDashBoard_Api(),
      };

      const entries = await Promise.all(
        Object.entries(requests).map(([key, req]) =>
          req.then((res) => [key, normalizeApiData(res), true]).catch(() => ["", [], false])
        )
      );

      if (!isMounted) return;

      const nextData = { ...EMPTY_DASHBOARD_DATA };
      entries.forEach(([key, value, ok]) => {
        if (ok) nextData[key] = value;
      });

      setData(nextData);
      setLoading(false);
      setSectionLoading(false);
    };

    fetchDashboardData();

    return () => {
      isMounted = false;
    };
  }, []);

  return { data, loading, sectionLoading };
};

export default useDashboardData;
